import Screen from '@/styles/Themes/Screen';
import styled from 'styled-components';
import { cssVars } from '@/styles/Themes/cssVars';
import Text from '@/styles/Themes/Text';
import Palette from '@/styles/Themes/Palette';

export const MainWrapper = styled.div`
    background: ${cssVars.bg_lightBlue_darker};
    position: relative;
    padding: 1px 0 32px;

    ${Screen.desktop} {
        padding: 32px;
    }
`;

export const MainContent = styled.div`
    display: flex;
    flex-direction: column;

    ${Screen.desktop} {
        gap: 2rem;
        display: grid;
        grid-template-columns: 1fr 1fr;
        align-items: start;
    }
`;

export const LeftBlock = styled.div`
    width: 100%;

    ${Screen.desktop} {
        max-width: 704px;
        margin-right: 20px;
    }
`;

export const ContentWrapper = styled.div`
    iframe,
    img {
        border-radius: 16px !important;
    }

    h1,
    h2,
    h3,
    h4 {
        color: ${Palette.green.normal};
        font-weight: 700;
    }
`;

export const ContentBlock = styled.div`
    width: 100%;

    ${Screen.desktop} {
        display: flex;
        margin-top: 40px;
    }
`;

export const BlogInfo = styled.div`
    z-index: 1;
    text-align: center;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;

    h1 {
        ${Text.Full.heading1}
        margin: 0;
        margin-bottom: 0.5rem;
        color: ${cssVars.fg_gray1_white};

        ${Screen.mobile} {
            font-size: 26px;
            line-height: 32px;
        }

        ${Screen.ipad} {
            font-size: 38px;
            line-height: 44px;
        }

        ${Screen.desktop} {
            font-size: 40px;
            line-height: 46px;
        }
    }

    h2 {
        ${Text.Full.heading2}
        color: ${cssVars.fg_gray1_white};
        margin-bottom: 1.5rem;
    }

    ${Screen.desktop} {
        text-align: left;
    }
`;

export const BlogDescription = styled.p`
    color: ${cssVars.fg_gray2_gray3};
    padding: 6px 20px;
    border: 1px solid ${Palette.green.normal};
    border-radius: 16px;
    margin-top: 20px;

    a {
        color: ${cssVars.fg_green_greenLight};
        text-decoration: underline;
        font-weight: 500;
    }

    div {
        ${Text.Full.medium.regular};
    }
    ul {
        padding-left: 10px;
        margin: 0;
    }

    li::marker {
        content: '- ';
    }
`;

export const Gradient = styled.div`
    background-image: ${cssVars.gradient_author};
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    top: 25%;
    opacity: 0.6;
`;

export const BlogImage = styled.div`
    z-index: 1;
    border-radius: 18px;
    overflow: hidden;
    background-color: ${cssVars.bg_white_blue};
    height: 100%;
    max-height: 174px;

    ${Screen.ipad} {
        max-height: 340px;
    }

    ${Screen.desktop} {
        max-height: 264px;
    }
`;

export const MainImage = styled.img`
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    max-height: 174px;

    ${Screen.ipad} {
        max-height: 340px;
    }

    ${Screen.desktop} {
        max-height: 264px;
    }
`;

export const Author = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    min-height: 38px;
    color: #4b5563;
    position: relative;
    margin-bottom: 24px;

    ${Screen.desktop} {
        margin-bottom: 0;
    }
`;

export const AuthorImage = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    overflow: hidden;
    z-index: 1;
    border: solid 1px ${Palette.sand.darkSand};
    background-color: ${Palette.sand.normal};
    position: absolute;
    top: 0;
    left: 0;

    span {
        display: block !important;
    }
    image {
        display: block;
    }
`;

export const AuthorText = styled.a`
    display: flex;
    background-color: ${cssVars.bg_white_blue};
    color: ${cssVars.fg_gray2_gray3};
    border-radius: 16px;
    border: solid 1px ${cssVars.bg_gray4_dark1};
    padding: 3px 16px 3px 44px;
    position: relative;
    text-decoration: none;

    ${Text.Full.medium.medium}
`;

export const AuthorMeta = styled.div`
    display: flex;
    align-items: center;

    span {
        display: flex;
        align-items: center;
    }

    &::before {
        content: '|';
        margin: 0 8px;
    }
`;

export const Location = styled.p`
    ${Text.Full.medium.medium};
    color: ${Palette.green.normal};
    padding: 4px 18px;
    display: flex;
    align-items: center;
    background-color: rgba(13, 209, 197, 0.1);
    border-radius: 16px;
    width: fit-content;
    margin: 0 auto 24px;

    ${Screen.desktop} {
        margin: 0 0 12px;
    }

    svg {
        margin-right: 6px;
    }
`;

export const AuthorStyle = styled.a`
    ${Text.Full.medium.semibold};
    color: ${Palette.green.normal};

    :hover {
        text-decoration: underline;
    }
`;

export const AuthorWrapper = styled.div`
    color: ${cssVars.fg_gray2_gray3};
    display: flex;
    width: 100%;
    justify-content: space-between;

    ${Screen.desktop} {
        max-width: 1064px;
    }
`;

export const TitleWrapper = styled.h1`
    ${Text.Full.heading2};
    color: ${cssVars.fg_gray1_white};
`;

export const WrapperSubscribe = styled.div`
    margin-top: 20px;

    > div {
        padding: 0 0 50px;

        ${Screen.ipad} {
            padding: 0 0 60px;
        }
    }
`;
